'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_YEARS_REQUEST: 'FETCH_YEARS_REQUEST',
    FETCH_YEARS_SUCCEEDED: 'FETCH_YEARS_SUCCEEDED',
    FETCH_YEARS_FAILED: 'FETCH_YEARS_FAILED',
    FETCH_YEAR_REQUEST: 'FETCH_YEAR_REQUEST',
    FETCH_YEAR_SUCCEEDED: 'FETCH_YEAR_SUCCEEDED',
    FETCH_YEAR_FAILED: 'FETCH_YEAR_FAILED',
    EDIT_YEAR_REQUEST: 'EDIT_YEAR_REQUEST',
    EDIT_YEAR_SUCCEEDED: 'EDIT_YEAR_SUCCEEDED',
    EDIT_YEAR_FAILED: 'EDIT_YEAR_FAILED',
    EDIT_YEAR_CANCELED: 'EDIT_YEAR_CANCELED',
    CREATE_YEAR_REQUEST: 'CREATE_YEAR_REQUEST',
    CREATE_YEAR_SUCCEEDED: 'CREATE_YEAR_SUCCEEDED',
    CREATE_YEAR_FAILED: 'CREATE_YEAR_FAILED'
};

function fetchYearsRequest() {
    return {
        type: actionTypes.FETCH_YEARS_REQUEST
    };
}

function fetchYearsSucceeded(years) {
    return {
        type: actionTypes.FETCH_YEARS_SUCCEEDED,
        years: years
    };
}

function fetchYearsFailed() {
    return {
        type: actionTypes.FETCH_YEARS_FAILED
    };
}

function fetchYearRequest(yearId) {
    return {
        type: actionTypes.FETCH_YEAR_REQUEST,
        yearId: yearId
    };
}

function fetchYearSucceeded(year) {
    return {
        type: actionTypes.FETCH_YEAR_SUCCEEDED,
        year: year
    };
}

function fetchYearFailed() {
    return {
        type: actionTypes.FETCH_YEAR_FAILED
    };
}

function editYearRequest(yearId, changes, redirect) {
    return {
        type: actionTypes.EDIT_YEAR_REQUEST,
        yearId: yearId,
        changes: changes,
        redirect: redirect
    };
}

function editYearSucceeded() {
    return {
        type: actionTypes.EDIT_YEAR_SUCCEEDED
    };
}

function editYearFailed() {
    return {
        type: actionTypes.EDIT_YEAR_FAILED
    };
}

function editYearCanceled() {
    return {
        type: actionTypes.EDIT_YEAR_CANCELED
    };
}

function createYearRequest(year, redirect) {
    return {
        type: actionTypes.CREATE_YEAR_REQUEST,
        year: year,
        redirect: redirect
    };
}

function createYearSucceeded() {
    return {
        type: actionTypes.CREATE_YEAR_SUCCEEDED
    };
}

function createYearFailed() {
    return {
        type: actionTypes.CREATE_YEAR_FAILED
    };
}

var actionCreators = {
    fetchYearsRequest: fetchYearsRequest,
    fetchYearsSucceeded: fetchYearsSucceeded,
    fetchYearsFailed: fetchYearsFailed,
    fetchYearRequest: fetchYearRequest,
    fetchYearSucceeded: fetchYearSucceeded,
    fetchYearFailed: fetchYearFailed,
    editYearRequest: editYearRequest,
    editYearSucceeded: editYearSucceeded,
    editYearFailed: editYearFailed,
    editYearCanceled: editYearCanceled,
    createYearRequest: createYearRequest,
    createYearSucceeded: createYearSucceeded,
    createYearFailed: createYearFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/years.js
// module id = 222
// module chunks = 0